import React from 'react';
import { Table } from 'reactstrap';


const TableComponent = ({ data, heading, keyInfo }) => {
    return (
        <Table responsive hover>
            <thead>
                <tr>
                    {
                        heading.map((head) => (
                            <th key={head}>
                                {head}
                            </th>
                        ))
                    }
                </tr>
            </thead>
            <tbody>
                {
                    data.map((info, index) => (
                        <tr key={index + 1}>
                            {
                                keyInfo.map((keys) => (
                                    <td key={`index${index} ${keys}`}>
                                        {info[keys]}
                                    </td>
                                ))
                            }
                        </tr>
                    ))
                }
            </tbody>
        </Table>
    );
};

export default TableComponent;